<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-collapse v-for="(item, index) in list" :key="index" v-model="activeNames" accordion>
      <van-collapse-item :title="item.name" :name="index">{{ item.body1 }}</van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey } from '@/utils/base'
import { Collapse, CollapseItem } from 'vant'
export default {
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    TopBar
  },
  data() {
    return {
      title: '帮助中心',
      backurl: '/users/index',
      activeNames: [],
      list: []
    }
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    request({
      url: '/data/getHelpList',
      method: 'post'
    }).then(response => {
      if (response.success) {
        this.list = response.data
        console.log(this.list)
      }
    })
  },
  methods: {
  }
}
</script>
